import config from "@app/config/getConfig";
import * as Sentry from "@sentry/react";
import { Logger } from "tslog";

const logger = new Logger({
  type: config.environment !== "development" ? "json" : "pretty",
  hideLogPositionForProduction: config.environment === "production",
  minLevel: config.environment !== "development" ? 3 : 0,
});

logger.attachTransport((logObj) => {
  const logLevel = logObj._meta.logLevelName.toLowerCase();
  if (["error", "fatal"].includes(logLevel)) {
    const message = Object.keys(logObj)
      .filter((key) => key !== "_meta")
      .map((key) => `${logObj[key]}`)
      .join("\n");
    Sentry.captureMessage(message, logLevel as Sentry.SeverityLevel);
  }
});

export default logger;
